import { VolunteeringHours } from '../../../../ui/features/time-tracking/components/VolunteeringHours';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { toKebabCase } from '../../../../ui/utils/toKebabCase';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { VolunteeringHoursStatus } from './VolunteeringHoursStatus';
const shiftParticipantLabelMap = {
    shiftStartTime: 'Shift Date',
    missionName: 'Missions',
    positionName: 'Position',
    hours: 'Hours',
    status: 'Status',
};
export const TableMobileColumns = ({ row, columnNames, handleAddHours }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2, flexGrow: 1 },
        React.createElement(Typography, { variant: 'subtitle2' }, row.columns.missionName),
        columnNames
            .filter((value) => value !== 'missionName')
            .map((columnName) => {
            let component = null;
            let columnValue = row.columns[columnName];
            const columnDataTest = `${toKebabCase(columnName)}-column`;
            switch (columnName) {
                case 'shiftStartTime':
                    columnValue = typeof columnValue === 'number' ? t('dateString', { value: columnValue }) : columnValue;
                    break;
                case 'hours':
                    component = (React.createElement(VolunteeringHours, { "data-test": columnDataTest, hours: row.columns.hours, hoursStatus: row.columns.hoursStatus }));
                    break;
                case 'status':
                    component = (React.createElement(VolunteeringHoursStatus, { "data-test": columnDataTest, participation: row, onAddHours: handleAddHours }));
                    break;
            }
            if (!component) {
                component = (React.createElement(Typography, { variant: 'body2', sx: { wordBreak: 'break-word' }, "data-test": columnDataTest }, columnValue));
            }
            return (React.createElement(Box, { key: row.id + `-${columnName}`, sx: { display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 } },
                React.createElement(Typography, { variant: 'subtitle2', sx: {
                        color: (theme) => theme.palette.grey['900'],
                        width: { sm: '50%' },
                    } }, shiftParticipantLabelMap[columnName]),
                component));
        })));
};
